/**
 * Store Pinia — loading
 *
 * Migré depuis `store/modules/loading.js`. Spinner global. Non persisté.
 *
 * Note : en Pinia, state et actions partagent `this`. L'ancien état `show` est donc
 * renommé `visible` pour éviter la collision avec l'action `show()`. L'API publique
 * reste identique : `show()`, `hide()`, getter `getLoading`.
 *
 * Équivalences Vuex → Pinia :
 *   - getters.getLoading → getters.getLoading (lit state.visible)
 *   - mutations.show     → actions.show
 *   - mutations.hide     → actions.hide
 */
import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    visible: false,
  }),

  getters: {
    getLoading: (state) => state.visible,
  },

  actions: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
  },
})
